// BatteryFetcher.js
//
// Battery catalogue for all vendors (cdpcode/battery/contexts).
import CoreBase from '../../../services/engines/CoreBase';
import batteryContextService from '../../../services/BatteryContextService';
import responseHelper from '../../../services/ResponseHelper';

const _name = 'BatteryFetcher';

class BatteryFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches all known battery contexts.
     * @returns {Promise<object[]>} contexts, empty on failure
     */
    fetch = async () => {
        try {
            const resp = await batteryContextService.getContexts();
            const code = responseHelper.check(resp, 'fetch', this._name);

            // Fetch failed — log via CoreBase, publishes to ErrorEngine
            if (code < 0) {
                this.logError('fetch', `getContexts failed — code=${code}`);
                return [];
            }

            const items = resp.data?.items ?? [];
            this.logDebug('fetch', `${items.length} contexts`);
            return items;
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

export default new BatteryFetcher();
